import styled from 'styled-components';

export const PageWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.background.base};
  min-height: 100vh;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 375px;
  min-height: calc(100vh - 110px);
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing(5, 5, 8)};
  display: flex;
  flex-direction: column;
  align-items: center;

  > :last-child {
    flex-shrink: 0;
  }
`;

export const ButtonContainer = styled.div`
  max-width: 335px;
  width: 100%;
`;

export const CenteredCarousel = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;
